<template>
	<component
		:is="tagName"
		class="eia-button"
		:class="classes"
		:to="path"
		:disabled="disabled"
		aria-role="button"
		@click="onClick">
		<slot name="icon"></slot>
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: 'eia-button',
	props: {
		size: {
			type: String,
			default: 'small',
			validator( value ) {
				return value.match( /small|large/ );
			},
		},
		variation: {
			type: String,
			default: 'default',
			validator( value ) {
				return value.match( /default|primary|success|light/ );
			},
		},
		path: {
			type: Object,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		tagName() {
			return this.path ? 'router-link' : 'button';
		},

		classes() {
			return {
				[ `eia-button--${this.size}` ]: true,
				[ `eia-button--${this.variation}` ]: true,
				'eia-button--disabled': this.disabled,
			};
		},
	},

	methods: {
		onClick() {
			this.$emit( 'click', ...arguments );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-button {
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	border: 1px solid transparent;

	font-family: $font-family;
	font-size: $text-subheading-small;
	font-weight: $weight-bold;
	user-select: none;

	padding: 18px;
	line-height: $text-subheading-small;

	cursor: pointer;

	text-decoration: none;
	transition:
		box-shadow 50ms linear,
		color 150ms linear,
		border-color 150ms linear,
		background 150ms linear;

	&--small {
		border-radius: $radius-full;
		min-width: 160px;
	}

	&--large {
		border-radius: $radius-default;
		min-width: 300px;
	}

	&--default {
		background: $color-white;
		color: $color-main;
		border-color: $color-main;
	}

	&--primary {
		background: $color-main;
		color: $color-white;
		border-color: $color-main;
	}

	&--success {
		background: $color-success;
		color: $color-main;
		border-color: $color-success;
	}

	&--light {
		background: transparent;
		color: $color-white;
		padding: 17px;
		margin: 1px;
		box-shadow: 0 0 0 1px $color-white;
	}

	&:focus {
		outline: none;
		border-color: currentColor;
	}

	&:hover {
		opacity: 0.9;
	}

	&:active {
		box-shadow: inset 0 0 2px currentColor;
	}

	&[disabled],
	&--disabled {
		pointer-events: none;
		background: $color-grey-light;
		color: $color-grey-dark;
		border-color: $color-grey-dark;
	}
}
</style>
